const showPricingTable = () => {
	const tableLink = document.querySelectorAll('a[href="#pricing-table"]');

	if (!tableLink.length) {
		return;
	}

	// eslint-disable-next-line @wordpress/no-global-event-listener
	document.addEventListener('DOMContentLoaded', () => {
		if (location.hash && '#pricing-table' === location.hash) {
			document.body.classList.add('show-table');
		}
	});

	// eslint-disable-next-line @wordpress/no-global-event-listener
	window.addEventListener('click', (event) => {
		if (event.target.matches('a[href="#pricing-table"]')) {
			document.body.classList.add('show-table');
		}
	});
};

export default showPricingTable;
